<template>
  <a-row>
    <a-col :span="labelCol" v-if="title">
      <div class="label-title">{{ title }}</div>
    </a-col>
    <a-col :span="valueCol">
      <div class="value" :style="valueStyle">{{ inputValue }}</div>
    </a-col>
  </a-row>
</template>

<script>
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  props: {
    value: {
      type: [String, Number]
    },

    title: {
      type: String,
      default: '标题'
    },

    labelCol: {
      type: Number,
      default: 4
    },

    valueCol: {
      type: Number,
      default: 16
    },

    valueStyle: String
  },
  setup (props) {
    const inputValue = ref(props.value)

    watch(props, e => {
      inputValue.value = e.value
    })

    return {
      inputValue
    }
  }
})
</script>

<style lang="less" scoped>
.must {
  position: absolute;
  top: 0;
  right: -10px;
  color: #f00;
  font-size: 18px;
  line-height: 32px;
}

.value {
  line-height: 32px;
}
</style>
